import type { input } from "zod";
import type { importWorkflowSchema } from "../../shared/mutators/importWorkflow";

// Leave room for Zero’s message envelope below its default 10 MiB WebSocket limit.
const MAX_IMPORT_ARGS_BYTES = 9 * 1024 * 1024;

export function workflowImportSizeError(
  args: input<typeof importWorkflowSchema>
): string | null {
  if (new Blob([JSON.stringify(args)]).size > MAX_IMPORT_ARGS_BYTES) {
    return "Workflow is too large to import. Remove some files or reduce their contents, then try again.";
  }
  return null;
}
